import { publicClient } from './wagmiConfig';

/**
 * Waits until the transaction is mined and reverts if status is not success.
 * Do not call backend sync until this resolves.
 */
export async function waitForSuccessfulTransactionReceipt(hash) {
    const receipt = await publicClient.waitForTransactionReceipt({
        hash,
        pollingInterval: 4_000,
        timeout: 180_000,
    });
    if (receipt.status !== 'success') {
        const error = new Error(
            'Transaction failed on-chain (revert or out-of-gas). Check the tx on Arcscan.',
        );
        error.receipt = receipt;
        throw error;
    }
    return receipt;
}
